class TabbedLinkCarousel extends HTMLElement {
  connectedCallback() {
    this.#distributeItems();
    this.#setupTabs();
    this.#setupArrows();
  }

  #distributeItems() {
    const staging = this.querySelector('.tabbed-link-carousel__staging');
    if (!staging) return;

    const items = staging.querySelectorAll('.tabbed-link-carousel__slide');
    items.forEach((item) => {
      const group = item.dataset.group || 'tab_1';
      const panel = this.querySelector(`[data-panel="${group}"]`);
      const scroller = panel?.querySelector('[data-scroller]');
      if (scroller) {
        scroller.appendChild(item);
      }
    });
  }

  #setupTabs() {
    this.querySelectorAll('[role="tab"]').forEach((tab) =>
      tab.addEventListener('click', () => this.#switchTab(tab))
    );
  }

  #switchTab(selected) {
    this.querySelectorAll('[role="tab"]').forEach((t) =>
      t.setAttribute('aria-selected', t === selected)
    );

    this.querySelectorAll('[role="tabpanel"]').forEach((p) => {
      p.hidden = p.dataset.panel !== selected.dataset.tab;
    });
  }

  #setupArrows() {
    this.querySelectorAll('.tabbed-link-carousel__panel').forEach((panel) => {
      const scroller = panel.querySelector('[data-scroller]');
      const prev = panel.querySelector('.slideshow-control--previous');
      const next = panel.querySelector('.slideshow-control--next');
      if (!scroller || !prev || !next) return;

      const scrollAmount = () => {
        const slide = scroller.querySelector('.tabbed-link-carousel__slide');
        if (!slide) return 300;
        return slide.offsetWidth + parseFloat(getComputedStyle(scroller).gap || 16);
      };

      prev.addEventListener('click', () => {
        scroller.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        scroller.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      const updateArrows = () => {
        const { scrollLeft, scrollWidth, clientWidth } = scroller;
        prev.disabled = scrollLeft <= 1;
        next.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
      };

      scroller.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();

      new ResizeObserver(updateArrows).observe(scroller);
    });
  }
}

customElements.define('tabbed-link-carousel', TabbedLinkCarousel);
